module.exports = __webpack_public_path__ + "img/profile-title.7f73be96.png";